// src/helpers/storage.ts

export const StorageKeys = {
  API_KEY: "api_key",
  API_SECRET: "api_secret",
  USER: "auth_user",
};
const storage = localStorage;
export function saveAuth(apiKey: string, apiSecret: string, user: any) {
  storage.setItem(StorageKeys.API_KEY, apiKey);
  storage.setItem(StorageKeys.API_SECRET, apiSecret);
  storage.setItem(StorageKeys.USER, JSON.stringify(user));
}

export function loadAuth() {
  return {
    api_key: storage.getItem(StorageKeys.API_KEY),
    api_secret: storage.getItem(StorageKeys.API_SECRET),
    user: JSON.parse(storage.getItem(StorageKeys.USER) || "null"),
  };
}

export function clearAuth() {
  storage.removeItem(StorageKeys.API_KEY);
  storage.removeItem(StorageKeys.API_SECRET);
  storage.removeItem(StorageKeys.USER);
}
